import { FormObject } from '@europrocurement/flexy-form/components';
import { FieldValues, UseFormReturn } from 'react-hook-form';

const checkFieldValue = function (
    formContext: UseFormReturn<FieldValues, FormObject>,
    valueToWatch: string | number | string[] | number[] | boolean,
    fieldNameToWatch: string,
) {
    const valueSelected = formContext.watch(fieldNameToWatch as string);

    if (Array.isArray(valueToWatch)) {
        const valueToWatchString = valueToWatch.map((v) => String(v));
        return typeof valueSelected === 'object'
            ? valueToWatchString.includes(String(valueSelected?.value))
            : valueToWatchString.includes(String(valueSelected));
    }

    return typeof valueSelected === 'object' || typeof valueSelected === 'function'
        ? String(valueSelected?.value) === String(valueToWatch)
        : String(valueSelected) === String(valueToWatch);
};

export default checkFieldValue;
